<header class="sim-usage-header">
  <div class="sim-usage-title-block">
    <i class="fa-solid fa-sim-card sim-usage-title-icon" aria-hidden="true"></i>
    <h1 class="sim-usage-page-title">SIM Usage Report</h1>
  </div>
  <div class="sim-usage-header__controls">
    <div class="sim-usage-fleet-wrap">
      <app-dropdown
        [control]="fleetControl"
        [options]="fleetOptions"
        [label]="''"
        placeholder="Select fleet"
        dataId="sim-usage-report-fleet"
      ></app-dropdown>
    </div>
    <button
      type="button"
      class="sim-usage-calendar-btn"
      aria-label="Open date range"
      (click)="onCalendarClick()"
    >
      <i class="fa-regular fa-calendar" aria-hidden="true"></i>
    </button>
  </div>
</header>

<section class="sim-usage-main-card" aria-labelledby="sim-usage-distribution-title">
  <div class="sim-usage-main-card__body">
    <div class="sim-usage-chart-side">
      <h2 id="sim-usage-distribution-title" class="sim-usage-section-title">
        Usage Distribution by Product
      </h2>
      <div class="sim-usage-chart-row">
        <div class="sim-usage-donut-wrap">
          <canvas id="simUsageDonutChart" role="img" aria-label="Usage distribution by product"></canvas>
          <div class="sim-usage-donut-center" aria-hidden="true">
            <p class="sim-usage-donut-center__value">{{ totalDevices | number }}</p>
            <p class="sim-usage-donut-center__label">Total Devices</p>
          </div>
        </div>
        <ul class="sim-usage-legend" aria-label="Product usage legend">
          @for (slice of productSlices; track slice.id) {
          <li class="sim-usage-legend__row">
            <span class="sim-usage-legend__dot" [style.background-color]="slice.color"></span>
            <span class="sim-usage-legend__name">{{ slice.label }}</span>
            <span class="sim-usage-legend__pct">{{ slice.pct }}%</span>
          </li>
          }
        </ul>
      </div>
    </div>

    <div class="sim-usage-vdivider" aria-hidden="true"></div>

    <div class="sim-usage-table-side">
      <div class="sim-usage-table-shell">
        <div class="sim-usage-table-toolbar">
          <div class="sim-usage-product-wrap" aria-label="Product code selection">
            <span class="sim-usage-product-wrap__label">Product Code</span>
            <span class="sim-usage-product-wrap__divider" aria-hidden="true"></span>
            <app-dropdown
              [control]="productCodeControl"
              [options]="productCodeOptions"
              [label]="''"
              placeholder="Code"
              dataId="sim-usage-report-product-code"
            ></app-dropdown>
          </div>
          <div class="sim-usage-search">
            <i class="fa-solid fa-magnifying-glass sim-usage-search__icon" aria-hidden="true"></i>
            <input
              type="search"
              class="sim-usage-search__input"
              placeholder="Search Devices"
              [(ngModel)]="deviceSearch"
              (ngModelChange)="onSearchInput()"
              aria-label="Search devices"
            />
          </div>
          <div class="sim-usage-toolbar-actions">
            <button
              type="button"
              class="sim-usage-icon-btn"
              aria-label="Download"
              (click)="onExportClick()"
            >
              <i class="fa-solid fa-download" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <div class="sim-usage-table-scroll">
          <table class="sim-usage-table">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Device ID</th>
                <th scope="col">Device SN</th>
                <th scope="col">SIM CCID</th>
                <th scope="col">Data Used</th>
                <th scope="col">Threshold</th>
                <th scope="col">% Used</th>
                <th scope="col">Last Seen</th>
              </tr>
            </thead>
            <tbody>
              @for (row of pagedDevices; track trackDevice($index, row); let i = $index) {
              <tr>
                <td>{{ globalRowOffset + i + 1 }}</td>
                <td>{{ row.deviceId }}</td>
                <td>{{ row.deviceSn }}</td>
                <td>{{ row.simCcid }}</td>
                <td>{{ formatMb(row.dataUsedMb) }}</td>
                <td>{{ formatMb(row.thresholdMb) }}</td>
                <td>
                  @if (isExceeded(row)) {
                  <span class="sim-usage-exceeded">
                    <i class="fa-solid fa-triangle-exclamation sim-usage-exceeded__icon" aria-hidden="true"></i>
                    <span class="sim-usage-exceeded__text">Exceeded</span>
                  </span>
                  } @else {
                  <span [class]="usagePctClass(row)">{{ pctUsed(row) }}%</span>
                  }
                </td>
                <td>{{ row.lastSeen }}</td>
              </tr>
              }
            </tbody>
          </table>
        </div>

        <nav class="sim-usage-pagination" aria-label="Table pagination">
          <button
            type="button"
            class="sim-usage-page-btn"
            aria-label="First page"
            [disabled]="currentPage <= 1"
            (click)="goFirst()"
          >
            <i class="fa-solid fa-angles-left" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            class="sim-usage-page-btn"
            aria-label="Previous page"
            [disabled]="currentPage <= 1"
            (click)="goPrev()"
          >
            <i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
          </button>
          @for (p of [1, 2, 3]; track p) {
          @if (p <= pageCount) {
          <button
            type="button"
            class="sim-usage-page-btn sim-usage-page-btn--num"
            [class.sim-usage-page-btn--active]="currentPage === p"
            (click)="goPage(p)"
          >
            {{ p }}
          </button>
          }
          }
          <button
            type="button"
            class="sim-usage-page-btn"
            aria-label="Next page"
            [disabled]="currentPage >= pageCount"
            (click)="goNext()"
          >
            <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            class="sim-usage-page-btn"
            aria-label="Last page"
            [disabled]="currentPage >= pageCount"
            (click)="goLast()"
          >
            <i class="fa-solid fa-angles-right" aria-hidden="true"></i>
          </button>
        </nav>
      </div>
    </div>
  </div>
</section>
